import React from "react";
import utils from "utils";
import Casesheet from "Pages/Others/Casesheet";
import PatientDetailConsultation from "./PatientDetailConsultation";
import PatientDetailAssessment from "./PatientDetailAssessment";
import PatientDetailPhi from "./PatientDetailPhi";
import PatientDetailBanner from "./PatientDetailBanner";
import api from "utils/api";
import icons from "Common/Icons";
import { connect } from "react-redux";
import "./Patient.scss";
import { gender, usertype } from "../../store/slice/patient-detail-slice";
import {
  Button,
  Col,
  Form,
  message,
  Modal,
  Row,
  Space,
  Switch,
  Drawer,
  Popover,
  Dropdown,
  BackTop,
} from "antd";
import { CONSTANTS } from "utils/constant";
import SubmitButton from "./SubmitButton";
import Loader from "Components/Loader";
import { pdfjs } from "react-pdf";
import PatientDetailBannerNew from "./PatientDetailBannerNew";
import CustomAppointmentCard from "Components/CustomAppointmentCard/CustomAppointmentCard";
import CustomPatientDetailsCard from "./CustomPatientDetailsCard";
import { FileTextOutlined } from "@ant-design/icons";
import BreadCrumbHistory from "Components/BreadCrumbHistory/BreadCrumbHistory";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
class PatientDetailNew extends React.Component {
  _baseClassName = "patient-detail-container";
  constructor(props) {
    super(props);
    this.state = {
      isSubscribed: true,
      logged_in_role: "patient",
      patient_info: {},
      patient_consultation_info: {},
      patient_phi_info: {},
      showPatientSettings: false,
      assessment_types: [],
      summary_link: "",
      isLoading: false,
      is_summary_generated: false,
      drawerVisible: false,
      consultationStatus: {},
      phiDrawer: false,
    };
    this.canvasRef = React.createRef();
    this.patientSettingsForm = React.createRef();
  }
  componentDidMount() {
    let keysToRemove = ["patient_id", "patient_user_type", "patient_gender"];
    for (let key of keysToRemove) {
      localStorage.removeItem(key);
    }
    this.getPatientDetails();
  }
  convertBase64ToPDF = (base64Data) => {
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const pdfBlob = new Blob([byteArray], { type: "application/pdf" });
    const new_pdf_file = new File([pdfBlob], "sample.pdf", {
      type: "application/pdf",
    });
    // saveAs(pdfBlob, 'sample' + '.pdf');
    return new_pdf_file;
  };

  file_to_jpg_conversion = async (file, joined_obj) => {
    const reader = new FileReader();
    reader.onload = async () => {
      const arrayBuffer = reader.result;

      // Load PDF document
      const pdfData = new Uint8Array(arrayBuffer);
      const loadingTask = pdfjs.getDocument({ data: pdfData });

      try {
        const pdf = await loadingTask.promise;
        const numPages = pdf.numPages;
        const convertedImages = [];

        for (let i = 1; i <= numPages; i++) {
          const page = await pdf.getPage(i);

          // Render PDF page on canvas
          const viewport = page.getViewport({ scale: 2.5 });
          const canvas = this.canvasRef.current;
          const context = canvas.getContext("2d");
          canvas.height = viewport.height;
          canvas.width = viewport.width;

          await page.render({ canvasContext: context, viewport }).promise;

          // Convert canvas to image (JPEG)
          const imgDataUrl = canvas.toDataURL("image/jpeg");
          convertedImages.push({
            // width: viewport.width,
            // height: viewport.height,
            url: imgDataUrl,
            page_no: i.toString(),
          });
        }
        let image_details = {
          url: convertedImages,
        };
        this.setState({ image_details: image_details, isLoading: false });
      } catch (error) {
        console.error("Error rendering PDF:", error);
        // this.setState({full_loading:false})
      }
    };
    reader.readAsArrayBuffer(file);
  };
  renderImage = () => {
    // let { imagesURL, zoomPercentag, imageWidth, imageHeight } = this.state;
    let images = [];
    if (!this.state?.image_details?.url) {
      return false;
    }
    this.state.image_details["url"].forEach((item) => {
      let src = item.url;
      images.push(<img src={src} style={{ width: "60vw" }} />);
    });
    return images;
  };
  getPatientDetails() {
    this.setState({ isLoading: true });
    let patient_id = this.props?.patient_id;
    api.get_patient_info({ patient_id: patient_id }).then((response) => {
      let reportURL = response.data.data?.reportURL || "";
      let patient_info = response?.data?.data || [];
      this.props.gender(patient_info?.gender);
      this.props.usertype(patient_info?.user_type);
      this.setState({
        patient_info: patient_info,
        patient_assessment_info: patient_info.assessment
          ? {
              ...patient_info.assessment,
              ...patient_info.assessment?.score,
            }
          : undefined,
        patient_phi_info: patient_info.phi,
        patient_consultation_info: {
          ...patient_info.consultation,
          patient_id: this.props?.patient_id,
        },
        assessment_types: this.transformAssessmentTypes(
          patient_info?.assessment_types
        ),
        is_summary_generated: response.data?.data?.is_summary_generated,
        summary_link: response.data?.data?.summary_link,
        consultationStatus: response.data.data?.consultation_status,
      });
      if (response.data?.data?.summary_link)
        this.file_to_jpg_conversion(
          this.convertBase64ToPDF(response.data?.data?.summary_link)
        );
      this.setState({ isLoading: false });
    });
  }

  caseSummaryReport() {
    let patient_id = this.props?.patient_id;
    this.setState({ isLoading: true });
    api
      .case_summary_report({ patient_id: patient_id })
      .then((response) => {
        if (response.data.status == 200) {
          message.info(response?.data?.message, ErrorDuration);
          this.setState({ isLoading: false });
          this.getPatientDetails();
        } else {
          message.error(response.data.message, ErrorDuration);
          this.setState({ isLoading: false });
        }
      })
      .catch((error) => {
        // console.log("Oops! Something went wrong.");
      });
  }

  handleActions(column, value) {
    if (column == "casesheet") {
      utils.Modal(true, {
        content: <Casesheet data={value} />,
        width: "850px",
      });
    } else {
      this.props.history.push({
        pathname: `/doctor/${column}`,
        default_tab: value,
      });
    }
  }

  transformAssessmentTypes(data) {
    return data?.map((item) => {
      return {
        key: item.key,
        label: item.label.charAt(0).toUpperCase() + item.label.slice(1),
        is_selected: item.is_selected,
      };
    });
  }

  patientSettingsSave(values) {
    let resultOptions = Object.entries(values).map(
      ([formItemName, formItemValue]) => {
        let tmpObj = this.state.assessment_types.find((obj) => {
          return obj.key === formItemName;
        });

        return {
          key: tmpObj.key,
          label: tmpObj.label,
          is_selected: formItemValue,
        };
      }
    );

    let submitData = {
      patient_id: this.props?.patient_id,
      data: {
        field_type: "radio",
        results: resultOptions,
      },
    };

    api
      .patient_settings_update(submitData)
      .then((res) => {
        message.success(res?.data?.message, ErrorDuration);
        this.setState({
          showPatientSettings: false,
          assessment_types: submitData.data.results,
        });
      })
      .catch((error) => {
        message.error("Oops! Something went wrong.", ErrorDuration);
      });
  }

  handleSettingsEdit() {
    this.setState({ showPatientSettings: true });
  }

  handleClose() {
    this.setState({ showPatientSettings: false });
  }
  onCloseDrawer() {
    this.setState({ drawerVisible: false });
  }
  render() {
    return (
      <>
        <canvas ref={this.canvasRef} style={{ display: "none" }} />
        {this.state.isLoading ? (
          <Loader />
        ) : (
          <>
            <div className={this._baseClassName}><BackTop  target={() =>  document.querySelector('.layout-main-container')} style={{color:"red"}}/>
              <div className="patient-detail-wrapper">
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Button
                    className="previous-page-button"
                    onClick={(e) => this.props.history.go(-1)}
                  >
                    {CONSTANTS.BACK_TO_PREVIOUS_PAGE}
                  </Button>
                  {/* <BreadCrumbHistory/> */}
                  {/* <Popover content={<div></div>} title="Title" placement="leftTop" trigger="click" showArrow={false}>
                    <Button type="primary">Hover me</Button>
                  </Popover> */}
                  <Dropdown
                    menu={{
                      items: [
                        {
                          key: "1",
                          label: this.state.summary_link && (
                            <a
                              onClick={(e) =>
                                this.setState({ drawerVisible: true })
                              }
                            >
                              {CONSTANTS.VIEW_REPORT}
                            </a>
                          ),
                        },
                        {
                          key: "2",
                          label: (
                            <a onClick={() => this.caseSummaryReport()}>
                              {CONSTANTS.CASE_SUMMARY_REPORT}
                            </a>
                          ),
                        },
                        {
                          key: "3",
                          label: this.state.summary_link && (
                            <div style={{ cursor: "initial" }}>
                              <img
                                className="tick-icon"
                                src={icons.filled_tick_icon}
                                alt="tick"
                              />
                              {
                                CONSTANTS.THIS_REPORT_WILL_AVAILABLE_FOR_24_HOURS
                              }
                            </div>
                          ),
                        },
                        {
                          key: "4",
                          label: this.state.is_summary_generated && (
                            <div style={{ cursor: "initial" }}>
                              <img
                                className="timer-icon"
                                src={icons.process_timer_icon}
                                alt="timer"
                              />
                              {CONSTANTS.CASE_SUMMARY_REPORT_IS_IN_PROGRESS}
                            </div>
                          ),
                        },
                      ],
                    }}
                    placement="bottomLeft"
                    trigger={"click"}
                    arrow
                  >
                    <Button
                      className="common-button-green"
                      style={{ width: "90px", height: "35px" }}
                    >
                      <FileTextOutlined />
                      Report
                    </Button>
                  </Dropdown>
                </div>
                <div className="page-header">
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      className="patient-name-header"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                    >
                      <label>
                        {utils.FirstNameLastName(
                          utils.FormatName(
                            utils.getDisplayName(
                              this.state.patient_info.patient_name,
                              this.state.patient_info.patient_last_name
                            )
                          ),
                          "450px"
                        )}
                      </label>
                      <div
                        className="patient-current-plan"
                        style={{ marginLeft: "unset" }}
                      >
                        <label>{this.state.patient_info?.patient_uid}</label>
                      </div>
                    </div>
                    {this.state?.patient_info?.display_plan_name && (
                      <div>
                        <div className="plan-type">
                          <img src={icons.membership_icon}></img>
                          <div className="plan-info">
                            {/* <div> {CONSTANTS.SUBSCRIBE_TO}</div> */}
                            <div className="plan-name">
                              {this.state.patient_info.display_plan_name}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    <div
                      style={{
                        display: "flex",
                        gap: "8px",
                        paddingLeft: "8px",
                        PaddingRight: "8px",
                        // flexDirection: "column",
                      }}
                    >
                      {[
                        {
                          value:
                            this.state.patient_consultation_info
                              ?.consultation_count || 0,
                          label: "Consultation Completed",
                          labelColor: "blue",
                          icon: "/users.svg",
                          // clickAction:()=>{},
                        },
                        {
                          value:
                            this.state.patient_consultation_info
                              ?.prescription_count || 0,
                          label: "Medicines prescribed for the Last consultation",
                          labelColor: "red",
                          icon: "/case.svg",
                          // clickAction:()=>{},
                        },
                        {
                          value: `${this.state.patient_phi_info?.percentage}%`,
                          // label: `${CONSTANTS.HEALTH_INFORMATION} Completed`,
                          label: `PHI Completed`,
                          labelColor: "green",
                          icon: "/check.svg",
                          clickAction: () => {
                            this.setState({ phiDrawer: true });
                          },
                        },
                      ].map((item, index) => (
                        <div
                          style={{
                            cursor: item?.clickAction ? "pointer" : "auto",
                          }}
                          onClick={item?.clickAction}
                          key={index}
                        >
                          <CustomPatientDetailsCard index={index} item={item} />
                        </div>
                      ))}
                    </div>
                  </div>
                  {/* <div>
                    <div className="case-summary-export-container">
                      {this.state.summary_link && (
                        <Button
                          onClick={(e) =>
                            this.setState({ drawerVisible: true })
                          }
                        >
                          {CONSTANTS.VIEW_REPORT}{" "}
                        </Button>
                      )}
                      <SubmitButton
                        className="export-btn"
                        label={CONSTANTS.CASE_SUMMARY_REPORT}
                        onClick={() => this.caseSummaryReport()}
                        loading={this.state.is_summary_generated}
                      />
                    </div>
                    <div
                      className={
                        this.state.summary_link ||
                        this.state.is_summary_generated
                          ? "case-summary-notify-txt"
                          : ""
                      }
                    >
                      {this.state.summary_link && (
                        <div>
                          <img
                            className="tick-icon"
                            src={icons.filled_tick_icon}
                          />{" "}
                          {CONSTANTS.THIS_REPORT_WILL_AVAILABLE_FOR_24_HOURS}
                        </div>
                      )}
                      {this.state.is_summary_generated && (
                        <div>
                          <img
                            className="timer-icon"
                            src={icons.process_timer_icon}
                          />
                          {CONSTANTS.CASE_SUMMARY_REPORT_IS_IN_PROGRESS}
                        </div>
                      )}
                    </div>
                  </div> */}
                </div>
                {/* <Row gutter={[12, 12]}>
                  {[
                    {
                      value:
                        this.state.patient_consultation_info
                          ?.consultation_count || 0,
                      label: "Consultation Completed",
                      labelColor: "blue",
                      icon: "/users.svg",
                      // clickAction:()=>{},
                    },
                    {
                      value:
                        this.state.patient_consultation_info
                          ?.prescription_count || 0,
                      label: "Medicines Prescribed",
                      labelColor: "red",
                      icon: "/case.svg",
                      // clickAction:()=>{},
                    },
                    {
                      value: `${this.state.patient_phi_info?.percentage}%`,
                      label: `${CONSTANTS.HEALTH_INFORMATION} Completed`,
                      labelColor: "green",
                      icon: "/check.svg",
                      clickAction:()=>{this.setState({phiDrawer:true})},
                    },
                  ].map((item, index) => (
                    <Col xs={24} md={24} lg={8} xl={8} style={{cursor:item?.clickAction?"pointer":"auto"}} onClick={item?.clickAction}>
                      <CustomPatientDetailsCard index={index} item={item} />
                    </Col>
                  ))}                  
                </Row> */}
                <PatientDetailBannerNew
                  status={this.state.consultationStatus}
                />
                <div className="patient-detail-content">
                  <div className="left-content">
                    {/* <PatientDetailAssessment
                data={this.state.patient_assessment_info}
                patientName={utils.FormatName(this.state.patient_info.patient_name)}
                patient_last_name={utils.FormatName(this.state.patient_info.patient_last_name)}
                patientUID={this.state.patient_info?.patient_uid}
                handleSettingsEdit={this.handleSettingsEdit.bind(this)}
                user_type={this.state.patient_info?.user_type}
              /> */}
                    {/* <PatientDetailConsultation
                data={this.state.patient_consultation_info}
                patientID={this.props.patient_id}
                handleActions={this.handleActions.bind(this)}
              /> */}
                  </div>
                  <div className="right-content">
                    <Drawer
                      title=""
                      width={640}
                      onClose={() => {
                        this.setState({ phiDrawer: false });
                      }}
                      open={this.state.phiDrawer}
                      closable={false}
                    >
                      <div className="phiDrawer">
                        <PatientDetailPhi
                          data={this.state.patient_phi_info}
                          patientName={utils.FormatName(
                            utils.getDisplayName(
                              this.state.patient_info.patient_name,
                              this.state.patient_info.patient_last_name
                            )
                          )}
                          patientUID={this.state.patient_info.patient_uid}
                        />
                      </div>
                    </Drawer>
                  </div>
                </div>
              </div>
              {this.state.showPatientSettings && (
                <Modal footer={null} closable={false} width={400} open>
                  <div className="patient-settings-container">
                    <Row
                      justify="end"
                      align="middle"
                      style={{
                        background: "#ECEAF2",
                        padding: "14px 14px 14px 21px",
                        borderRadius: "8px",
                      }}
                    >
                      <Col span={14}>
                        <h3>{CONSTANTS.ASSESSMENT_SETTINGS}</h3>
                      </Col>
                      <Col span={10}>
                        <Space size="middle">
                          <Button
                            shape="round"
                            style={{
                              background: "#107569",
                              color: "white",
                              border: "none",
                            }}
                            onClick={(e) =>
                              this.patientSettingsForm.current.submit()
                            }
                          >
                            {CONSTANTS.SAVE}
                          </Button>
                          <Button
                            shape="round"
                            onClick={this.handleClose.bind(this)}
                            style={{
                              background: "#e62925",
                              color: "white",
                              border: "none",
                            }}
                          >
                            {CONSTANTS.CLOSE}
                          </Button>
                        </Space>
                      </Col>
                    </Row>
                    <Row style={{ paddingTop: "15px" }}>
                      <Col span={24}>
                        <Form
                          name="patientSettingsForm"
                          ref={this.patientSettingsForm}
                          labelCol={{ span: 10 }}
                          wrapperCol={{ span: 14 }}
                          layout="horizontal"
                          onFinish={this.patientSettingsSave.bind(this)}
                        >
                          {this.state.assessment_types.map((item) => (
                            <Form.Item
                              key={item.key}
                              name={item.key}
                              label={item.label}
                              valuePropName="checked"
                              initialValue={item.is_selected}
                            >
                              <Switch />
                            </Form.Item>
                          ))}
                        </Form>
                      </Col>
                    </Row>
                  </div>
                </Modal>
              )}
            </div>
            <Drawer
              destroyOnClose={true}
              closable={false}
              width={"65vw"}
              title="CaseSheet Summary"
              open={this.state.drawerVisible}
              extra={
                <Button
                  className="close-button"
                  onClick={this.onCloseDrawer.bind(this)}
                >
                  {CONSTANTS.CLOSE}
                </Button>
              }
            >
              <div>{this.renderImage()}</div>
            </Drawer>
          </>
        )}
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    patient_id: state.patientDetailReducer.patient_detail,
  };
};
const mapDispatchToProps = {
  gender,
  usertype,
};
export default connect(mapStateToProps, mapDispatchToProps)(PatientDetailNew);
